import getImageUrlWithoutQuery from 'commons/getImageUrlWithoutQuery';

const getValidImageUrls = (images, brokenImageUrls) =>
  images.filter(({ src }) => {
    const cleanImageUrl = getImageUrlWithoutQuery(src);
    // Remove any broken images from the array passed to the gallery modal
    return !!cleanImageUrl && !brokenImageUrls.includes(cleanImageUrl);
  });

export default getValidImageUrls;
